export default __webpack_public_path__ + "static/illustration-do-ab39a5d6ce4d431710015fe7d9cfdbace9897ef1c3ba6ff41e724f0e495d5e1b.png";